import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useState, useRef, useCallback, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/ExpandText.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ExpandText = function ExpandText(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick;

  var _useState = useState(false),
      more = _useState[0],
      setMore = _useState[1];

  var _useState2 = useState(),
      open = _useState2[0],
      setOpen = _useState2[1];

  var containerRef = useRef();
  var textRef = useRef();
  var toggle = useCallback(function () {
    setOpen(!open);

    if (typeof onClick == "function") {
      onClick();
    }
  }, [open]);
  useEffect(function () {
    if (typeof open === "undefined") {
      var containerHeight = containerRef.current.clientHeight;
      var textHeight = textRef.current.clientHeight;

      if (containerHeight < textHeight) {
        setMore(true);
      } else {
        setMore(false);
      }

      setOpen(false);
    }
  }, [open, containerRef.current, textRef.current]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles["expand-text"], (_classnames = {}, _defineProperty(_classnames, styles.open, open === true), _defineProperty(_classnames, styles.withMore, more), _classnames), className),
    ref: containerRef,
    children: [/*#__PURE__*/_jsx("div", {
      ref: textRef,
      children: React.Children.map(children, function (child, i) {
        var _classnames2;

        return /*#__PURE__*/React.cloneElement(child, {
          className: classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.firstNode, i == 0), _defineProperty(_classnames2, styles.ellipsis, open === false && i == 0), _defineProperty(_classnames2, styles.otherNode, i > 0), _classnames2))
        });
      })
    }), more && /*#__PURE__*/_jsx("div", {
      className: classnames(styles.showMoreBtn, _defineProperty({}, styles.open, open === true)),
      children: /*#__PURE__*/_jsx("button", {
        onClick: toggle,
        children: open === true ? "元に戻す" : "もっと詳しく"
      })
    })]
  });
};

export default ExpandText;